import { render, staticRenderFns } from "./DraftMessageListTab.vue?vue&type=template&id=accf3f24&scoped=true&lang=pug"
import script from "./DraftMessageListTab.vue?vue&type=script&lang=ts"
export * from "./DraftMessageListTab.vue?vue&type=script&lang=ts"
import style0 from "./DraftMessageListTab.vue?vue&type=style&index=0&id=accf3f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf3f24",
  null
  
)

export default component.exports